/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ReactElement } from "react"

import ErrorGettingInvite from "./inviteScreens/errorGettingInvite"
import AccountSetUpProvider from "./providers/firstLoginProvider"
import ScreenPicker from "./screenPicker"
import { useGetState } from "../../hooks/useGetState"
import { getShowAccountSetUp } from "../../redux/preferencesSlice"
import { OPEN } from "../../redux/types"
import useCanClaimDomain from "../../services/middleware/hooks/account/useCanClaimDomain"
import useCheckInvites from "../../services/middleware/hooks/account/useCheckInvites"
import AppDialog from "../dialog/appDialog"
import FirstLoginSkeleton from "../loading/skeletons/firstLoginSkeleton"
import DisplayIfElse from "../wrappers/displayIfElse"

/** Content for account set up dialogue entry point */
const AccountSetUpDialogContent = (): ReactElement => {
    const { isChecking, hasInvite, error, mutate, invite } = useCheckInvites()
    const { canClaimDomain, isCheckingDomain } = useCanClaimDomain()

    return isChecking || isCheckingDomain ? (
        <FirstLoginSkeleton />
    ) : (
        <DisplayIfElse
            condition={!!error}
            displayIfTrue={
                <ErrorGettingInvite
                    retry={() => mutate()}
                    errorDetail={error?.displayDetail || ""}
                />
            }
            displayIfFalse={
                <DisplayIfElse
                    condition={!!hasInvite}
                    displayIfTrue={
                        <AccountSetUpProvider
                            isInviteMode
                            canClaimDomain={false}
                            invite={invite!}
                        >
                            <ScreenPicker />
                        </AccountSetUpProvider>
                    }
                    displayIfFalse={
                        <AccountSetUpProvider
                            isInviteMode={false}
                            canClaimDomain={canClaimDomain || false}
                        >
                            <ScreenPicker />
                        </AccountSetUpProvider>
                    }
                />
            }
        />
    )
}

/** Entry point for the account set up dialog */
const AccountSetUpDialog = (): ReactElement => {
    const dialogueState = useGetState(getShowAccountSetUp)

    return (
        <AppDialog
            isFullscreen
            isOpen={dialogueState === OPEN}
            sx={{ padding: 2 }}
        >
            <AccountSetUpDialogContent />
        </AppDialog>
    )
}

export default AccountSetUpDialog
